module.exports = __webpack_public_path__ + "img/chat.f3df2774.svg";